import React,{useState} from 'react'
import { useDispatch } from 'react-redux';
import { Modal } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import {changeHomeTab,createPurpose} from '../store/actions/CommonAction'
import { ToastContainer, toast } from 'react-toastify';
import { TimeoutLogic } from "../utils/TimeoutLogic";
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import TextField from '@mui/material/TextField';
import {getPurpose} from '../store/actions/CommonAction';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
      padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
      padding: theme.spacing(1),
    },
  }));

const CreatePurpose = ( { open, onClose }, props) => {

const dispatch = useDispatch()
const [show, setShow] = useState(false);
const [name,setName] = useState('');
const [desc,setDesc] = useState('');
const [showPurposeSuccess, setShowPurposeSuccess] = useState(false);
const [showPurposeModal, setShowPurposeModal] = useState(false);


const [values, setValues] = useState({
    select1: '',
  });

const handleShow = () => setShow(!show);

const handleShowPurposeSuccess = () => {
    setShowPurposeSuccess(!showPurposeSuccess);
    setShowPurposeModal(!showPurposeModal);
}

const handleClose = () => {
    onClose(false);
  };

const save = async( event) =>{
    event.preventDefault(); 
    try{
        await dispatch(createPurpose(name,desc))
        handleShow()
    }catch(e){
        console.log("error", e , JSON.stringify(e))
        toast.error("Something went wrong, please try again later.");

    }
}

const savePurpose = async (event) => {
    event.preventDefault();
    if (name === null || name.trim() === '' ) {
      toast.error("Purpose cannot be empty")
    }else if(desc === null || desc.trim() === ''){
      toast.error("Purpose Description cannot be empty")
    }
    else {
    
        await dispatch(createPurpose(name, desc))
        await dispatch(getPurpose())
        handleShowPurposeSuccess()
        onClose(false);
    
  }
  //toast.success('Purpose created successfully')
}

const closePrpModal = () => {
    setShowPurposeModal(!showPurposeModal)

}

const nav = async( ) =>{
    handleShow()
    await dispatch(changeHomeTab("6"))
    props.history.push("/purposelist")
} 


    return (
        <>
        <BootstrapDialog
          onClose={handleClose}
          open={open}
          className='custom-diaog-sm'
        >
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
          <DialogContent>
            <div className='row'>
              <div className='col-md-12'>
                <h3 className='pop-title'>Create Purpose</h3>
              </div>
            </div>
                <div class="card custom-cards dark no-shadow my-4">
                    <div class="card-body">
                        <div className='row'>
                            <div className='col-md-12'>
                                <div className="mb-3">
                                    <TextField label="Purpose" variant="standard" className='w-100'
                                    maxLength="200" required 
                                    pattern="^([A-Za-z]+[,.]?[ ]?|[A-Za-z]+['-]?)+$"
                                    onChange={(event)=> setName(event.target.value)}
                                    />
                                </div>
                                <div className='mb-3'>
                                    <TextField
                                        fullWidth
                                        size='small'
                                        label='Purpose Description'
                                        variant='standard'
                                        name='select1'
                                        //value={values.select1}
                                        maxLength="200000" 
                                        required 
                                        onChange={(event)=> setDesc(event.target.value)}
                                    >
                                    </TextField>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-md-12 text-end'>
                        {/* <button type="button" onClick={closePrpModal} className='btn btn-outline-primary me-2'>Close</button> */}
                        <button type="button" onClick={savePurpose} className='btn btn-primary'>Create</button>
                    </div>
                </div>
            
          </DialogContent>
        </BootstrapDialog>
        <Modal show={show} onHide={handleShow} backdrop="static">
            <Modal.Header >
                <Modal.Title>Successful!!</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <span>Your purpose has been saved successfully.</span>
            </Modal.Body>
            <Modal.Footer>
                <button  onClick={nav} className="btn btn-outline-primary btn-sm" >Ok</button>
            </Modal.Footer>
        </Modal>
        
        {/* <ToastContainer 
            // type={toastType}
            // theme={'colored'}
            />
       */}
      <TimeoutLogic/>
      </>   
    )
}

export default CreatePurpose;


